import {useMutation, useQueryClient} from "@tanstack/react-query";
import {GlobalVariables, GlobalVariablesBase} from "../../model/GlobalVariables";
import {SiteBunnyAdminError, toSiteBunnyAdminError} from "../../error";
import globalVariablesRepository from "../../repository/GlobalVariablesRepository";

export const useCreateGlobalVariables = () => {
    const queryClient = useQueryClient();

    return useMutation<GlobalVariables, SiteBunnyAdminError, GlobalVariablesBase>({
        mutationKey: ['globalVariable', 'create'],
        mutationFn: async (body: GlobalVariablesBase) => {
            try {
                const {data} = await globalVariablesRepository.create(body);
                return data.result;
            } catch (e) {
                throw toSiteBunnyAdminError(e);
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries(['globalVariable'])
        }
    })
};
